/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { PlaygroundLoader } from "components/playground/PlaygroundLoader";
import { useParams } from "react-router-dom";

const viewTestId = "atp-sandbox-view";

export const SandboxView = () => {
  const { userName, sandboxName } = useParams();

  if (!userName || !sandboxName)
    throw new Error("Invalid route params");

  return <PlaygroundLoader userName={userName} sandboxName={sandboxName} viewTestId={viewTestId}/>
};
